import { get, writable } from "svelte/store";
export class ModelLocationInfoManager {
    constructor(parent) {
        this.collapsedStore = writable(false);
        this.modelTranslationKeyStore = parent.getModelTranslationKeyStore();
        this.selectedLocationStore = parent.getSelectedLocationStore();
        this.showCyclingScoreStore = parent.getShowCyclingScoreStore();
    }
    onToggleCollapsed() {
        this.collapsedStore.set(!get(this.collapsedStore));
    }
    getCollapsedStore() {
        return this.collapsedStore;
    }
    getModelTranslationKeyStore() {
        return this.modelTranslationKeyStore;
    }
    getSelectedLocationStore() {
        return this.selectedLocationStore;
    }
    getShowCyclingScoreStore() {
        return this.showCyclingScoreStore;
    }
}
